<!-- <div class="container"> -->
<div class="accordion ttp-accordion" id="steps-accordion">

  <div class="answers">
    @if (currentStep > 0) {
      <span>{{'HOME.COMPARISON_STEPPER.ANSWERS' | translate }}: {{ selectedAnswerStr }}</span>
    }
  </div>

  <div class="steps">
    <div class="step-item" [ngClass]="{'step-complete' : currentStep >= 0}">
      <span></span>
    </div>
    <div class="step-item" [ngClass]="{'step-complete' : currentStep >= 1}">
      <span></span>
    </div>
    <div class="step-item" [ngClass]="{'step-complete' : currentStep === 2}">
      <span></span>
    </div>
    <!-- <div class="step-item" [ngClass]="{'step-complete' : currentStep === 3}">
    <span></span>
  </div> -->
</div>

<div class="step-title">
  <span class="step-count step-count-current">{{currentStep + 1}}</span>
  <span class="step-count step-count-total"> of 3</span> <span style="font-size: 2em; padding-left: 15px;">{{ stepTitles[this.currentStep] | translate }}</span>
</div>

<div class="card">
  <div id="compCollapse1" class="collapse compCollapse show" aria-labelledby="headingOne"
    data-bs-parent="#steps-accordion">
    <div class="card-body">
      <p>{{'HOME.COMPARISON_STEPPER.STEP_INSTRUCTIONS' | translate}}</p>
      <div class="radios-container">
        <div class="radio-wrapper">
          <label class="btn comparison-radio" for="usCit">
            <input type="radio" id="usCit" name="citizenship" [(ngModel)]="citizenship"  (click)="toggleCountrySelect('us')" value="us" />
            <div>
              <p>{{'HOME.COMPARISON_STEPPER.STEPS.ONE.OPTION1.LABEL' | translate}}</p>
              <p>{{'HOME.COMPARISON_STEPPER.STEPS.ONE.OPTION1.SUB_LABEL' | translate}}</p>
            </div>
          </label>
        </div>
        <div class="radio-wrapper">
          <label class="btn comparison-radio" for="caCit">
            <input type="radio" id="caCit" name="citizenship" [(ngModel)]="citizenship" (click)="toggleCountrySelect('ca')" value="ca" />
            <div>
              <p>{{'HOME.COMPARISON_STEPPER.STEPS.ONE.OPTION2.LABEL' | translate}}</p>
              <p>{{'HOME.COMPARISON_STEPPER.STEPS.ONE.OPTION2.SUB_LABEL' | translate}}</p>
            </div>
          </label>
        </div>

        <div class="radio-wrapper">
          <label class="btn comparison-radio" for="mxCit">
            <input type="radio" id="mxCit" name="citizenship" [(ngModel)]="citizenship"  value="mx" (click)="toggleCountrySelect('mx')"/>
            <div>
              <p>{{'HOME.COMPARISON_STEPPER.STEPS.ONE.OPTION3.LABEL' | translate}}</p>
              <p>{{'HOME.COMPARISON_STEPPER.STEPS.ONE.OPTION3.SUB_LABEL' | translate}}</p>
            </div>
          </label>
        </div>
        <div class="radio-wrapper">
          <label class="btn comparison-radio" for="noneCit">
            <input type="radio" id="noneCit" name="citizenship" [(ngModel)]="citizenship" value="none" (click)="toggleCountrySelect('none')"/>
            <div>
              <p>{{'HOME.COMPARISON_STEPPER.STEPS.ONE.OPTION4.LABEL' | translate}}</p>
              <p>{{'HOME.COMPARISON_STEPPER.STEPS.ONE.OPTION4.LABEL' | translate}}</p>
            </div>
          </label>
        </div>
      </div>

      <div class="ms-3 mt-5">
        <p id="otherCountry_label">{{'HOME.COMPARISON_STEPPER.NONE_OF_THE_ABOVE' | translate}}</p>
        <div class="select-div">
          <select id="select-citizenship" name="select-citizenship" class="form-select mt-4" [(ngModel)]="selectedCitizenship"
                    (change)="setSelectedText($event)" aria-labelledby="otherCountry_label" disabled>
            <option value="">{{'HOME.COMPARISON_STEPPER.SELECT' | translate }}</option>

            @for (country of geEligCountries; track country[0]) {
                <option [value]="country[0]">{{country[1]}}</option>
            }
            <option value="OTHER" translate>HOME.COMPARISON_TOOL.CIT_COUNTRIES.OTHER_CITIZEN</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Primary Travel Destination -->
<div class="card">
  <div id="compCollapse2" class="collapse compCollapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
    <div class="card-body">
      <p>{{'HOME.COMPARISON_STEPPER.STEP_INSTRUCTIONS' | translate}}</p>
      <div class="radios-container">
        <div class="radio-wrapper">
          <label class="comparison-radio" for="domesticDest">
            <input type="radio" id="domesticDest" name="travelDestination" [(ngModel)]="travelDestination"  value="us" />
            <div>
              <p>{{'HOME.COMPARISON_STEPPER.STEPS.TWO.OPTION1.LABEL' | translate}}</p>
              <p>{{'HOME.COMPARISON_STEPPER.STEPS.TWO.OPTION1.SUB_LABEL' | translate}}</p>
            </div>
          </label>
        </div>
        <div class="radio-wrapper">
          <label class="comparison-radio" for="canadaDest">
            <input type="radio" id="canadaDest" name="travelDestination" [(ngModel)]="travelDestination" value="ca" />
            <div>
              <p>{{'HOME.COMPARISON_STEPPER.STEPS.TWO.OPTION2.LABEL' | translate}}</p>
              <p>{{'HOME.COMPARISON_STEPPER.STEPS.TWO.OPTION2.SUB_LABEL' | translate}}</p>
            </div>
          </label>
        </div>

        <div class="radio-wrapper">
          <label class="comparison-radio" for="mxDest">
            <input type="radio" id="mxDest" name="travelDestination" [(ngModel)]="travelDestination" value="mx" />
            <div>
              <p>{{'HOME.COMPARISON_STEPPER.STEPS.TWO.OPTION3.LABEL' | translate}}</p>
              <p>{{'HOME.COMPARISON_STEPPER.STEPS.TWO.OPTION3.SUB_LABEL' | translate}}</p>
            </div>
          </label>
        </div>
        <div class="radio-wrapper">
          <label class="comparison-radio" for="intDest">
            <input type="radio" id="intDest" name="travelDestination" [(ngModel)]="travelDestination" value="int" />
            <div>
              <p>{{'HOME.COMPARISON_STEPPER.STEPS.TWO.OPTION4.LABEL' | translate}}</p>
              <p>{{'HOME.COMPARISON_STEPPER.STEPS.TWO.OPTION4.SUB_LABEL' | translate}}</p>
            </div>
          </label>
        </div>
      </div>

      <div class="mt-5">
        <p class="mb-2">{{'HOME.COMPARISON_STEPPER.STEPS.TWO.DO_YOU_HAVE_A_PASSPORT' | translate}}</p>
        <div class="radios-container">
          <div class="radio-wrapper">
            <label class="comparison-radio" for="havePassportYes">
              <input type="radio" id="havePassportYes" name="havePassport" [(ngModel)]="havePassport"  value="yes" />{{'GENERAL_REUSABLE.YES_BUTTON' | translate}}
            </label>
          </div>
          <div class="radio-wrapper">
            <label class="comparison-radio" for="havePassportNo">
              <input type="radio" id="havePassportNo" name="havePassport" [(ngModel)]="havePassport"  value="no" />{{'GENERAL_REUSABLE.NO_BUTTON' | translate}}
            </label>
          </div>
        </div>
      </div>


      <div class="mt-5">
        <p class="mb-2">{{'HOME.COMPARISON_STEPPER.STEPS.TWO.ARE_YOU_A_TRUCKER' | translate}}</p>
        <div class="radios-container">
          <div class="radio-wrapper">
            <label class="comparison-radio" for="truckDriverYes">
              <input type="radio" id="truckDriverYes" name="truckDriver" [(ngModel)]="truckDriver" value="yes" />Yes
            </label>
          </div>
          <div class="radio-wrapper">
            <label class="comparison-radio" for="truckDriverNo">
              <input type="radio" id="truckDriverNo" name="truckDriver" [(ngModel)]="truckDriver" value="no" />No
            </label>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<div class="card">
  <div id="compCollapse4" class="collapse compCollapse" aria-labelledby="headingFour"
    data-bs-parent="#accordionExample">
    <div class="card-body">
      <app-stepper-recommendation></app-stepper-recommendation>
    </div>
  </div>
</div>

<div class="mt-5 mb-5 wizard-button-row w-100 d-flex justify-content-between">
  @if (currentStep > 0) {
    <a  href="javascript:void(0)" (click)="backStep()" (keyup.enter)="backStep()">Go Back</a>
  }
  @if (currentStep < 2) {
    <button class="btn btn-primary ms-auto" (click)="nextStep()" [disabled]="!isCurrentStepValid()">
      <span translate>{{'GENERAL_REUSABLE.NEXT_BUTTON' | translate | titlecase }}</span>
    </button>
  }
</div>
</div>
<!-- </div> -->
